import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialJiraIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialJira",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.19 15.21 17.15 3.17 15.98 2l-9.06 9.07-4.14 4.14c-.43.43-.43 1.13 0 1.56l8.28 8.28L15.99 30l9.07-9.06.13-.14 4.01-4.01c.45-.42.48-1.11.05-1.56-.01-.01-.03-.03-.05-.03Zm-13.21 4.92L11.84 16l4.14-4.14L20.12 16z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m14.1 20.74-4.77-4.82 4.64-4.63c-.38-.4-.78-.81-1.16-1.25a8.54 8.54 0 0 1-2.24-5.29L.43 14.89c-.57.57-.57 1.49 0 2.06l14.48 14.48a1.455 1.455 0 0 0 2.26-.25c1.12-1.79 2.39-4.92-.14-7.45-1.48-1.47-2.92-2.98-2.93-2.99m3.8-9.64 4.77 4.82-4.63 4.63c.38.4.78.82 1.16 1.25a8.53 8.53 0 0 1 2.23 5.29l10.14-10.14c.57-.57.57-1.49 0-2.06L17.11.43c-.56-.57-1.48-.58-2.06-.02-.08.08-.16.17-.22.28-1.1 1.82-2.33 4.96.13 7.42 1.49 1.48 2.93 2.97 2.94 2.98Z"
      })
    })
  }));
};
SocialJiraIcon.displayName = 'SocialJiraIcon';